import request from "@/util/request";

export default {

  /**
   * 获取申请列表
   */
  getOrders: function() {
    return request({
      url: "/user/common/apply/getOrders",
      method: "get",
    });
  }
};
